import {
  createEffectTheme
} from "./chunk-WUUZD6PV.mjs";
import {
  createColorTheme
} from "./chunk-WEX4HY5P.mjs";
import {
  createComponentTheme
} from "./chunk-4GDTFSJV.mjs";
import {
  __spreadValues
} from "./chunk-LK3IYL3P.mjs";

// src/utils/createMetaTheme.ts
var createMetaTheme = (config) => {
  var _a, _b, _c;
  const baseTheme = __spreadValues(__spreadValues({}, createColorTheme((_a = config.colors) != null ? _a : {})), createEffectTheme(config.effects));
  return __spreadValues(__spreadValues({}, baseTheme), createComponentTheme(baseTheme, (_c = (_b = config.components) == null ? void 0 : _b.call(config, baseTheme)) != null ? _c : {}));
};

export {
  createMetaTheme
};
